import React from "react";

export default function Maintenance() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        
        {/* Logo / Title */}
        <h1 style={styles.title}>🚧 Under Maintenance</h1>

        <p style={styles.subtitle}>
          Our website is currently undergoing scheduled maintenance.
        </p>

        <p style={styles.text}>
          We’re working hard to improve your experience. Please check back soon.
        </p>

        {/* Divider */}
        <div style={styles.divider}></div>

        {/* Contact */}
        <p style={styles.contact}>
          For urgent queries, contact us at <br />
          <b>info@icsaj.com</b>
        </p>

        {/* Footer */}
        <p style={styles.footer}>© 2026 ICSAJ. All Rights Reserved.</p>

      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    textAlign: "center",
    maxWidth: "500px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  title: {
    fontSize: "32px",
    marginBottom: "10px",
    color: "#333",
  },
  subtitle: {
    fontSize: "18px",
    marginBottom: "10px",
    color: "#666",
  },
  text: {
    fontSize: "14px",
    color: "#777",
    marginBottom: "20px",
  },
  divider: {
    height: "2px",
    background: "#eee",
    margin: "20px 0",
  },
  contact: {
    fontSize: "14px",
    color: "#444",
  },
  footer: {
    marginTop: "20px",
    fontSize: "12px",
    color: "#999",
  },
};